import { render, staticRenderFns } from "./FormGroup.vue?vue&type=template&id=408357c6"
import script from "./FormGroup.vue?vue&type=script&lang=js"
export * from "./FormGroup.vue?vue&type=script&lang=js"
import style0 from "./FormGroup.vue?vue&type=style&index=0&id=408357c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports